import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import { Headers, Http, RequestOptions } from '@angular/http';
var WalletDetailService = /** @class */ (function (_super) {
    tslib_1.__extends(WalletDetailService, _super);
    function WalletDetailService(http, httpP) {
        var _this = _super.call(this, 'wallet-detail', http) || this;
        _this.http = http;
        _this.httpP = httpP;
        return _this;
    }
    WalletDetailService.prototype.ngOnInit = function () {
    };
    WalletDetailService.prototype.addAdjust = function (data, signature) {
        var header = new Headers();
        header.append('Signature', signature);
        var options = new RequestOptions({ headers: header });
        return this.httpP.post("https://api-admin-v2.latipay.net/apm/manual/regulation", data, options).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return WalletDetailService;
}(BaseService));
export { WalletDetailService };
